/**
 * @generated SignedSource<<6207d8c6f112ed842c69cc354b318e93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetStatus = "AVAILABLE" | "IN_USE" | "LOST" | "MAINTENANCE" | "RETIRED" | "%future added value";
export type UpdateKitInput = {
  clientMutationId?: string | null | undefined;
  dailyRate?: number | null | undefined;
  description?: string | null | undefined;
  kitId: string;
  notes?: string | null | undefined;
  rentable?: boolean | null | undefined;
  status?: AssetStatus | null | undefined;
};
export type OpsKitPageUpdateMutation$variables = {
  input: UpdateKitInput;
};
export type OpsKitPageUpdateMutation$data = {
  readonly updateKit: {
    readonly kit: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsKitPageUpdateMutation = {
  response: OpsKitPageUpdateMutation$data;
  variables: OpsKitPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateKitPayload",
    "kind": "LinkedField",
    "name": "updateKit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "kit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsKitPageUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsKitPageUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "42eb591f71f69a59a56e40d3b7802f22",
    "id": null,
    "metadata": {},
    "name": "OpsKitPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsKitPageUpdateMutation(\n  $input: UpdateKitInput!\n) {\n  updateKit(input: $input) {\n    kit {\n      id\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8bc14beecf30b87a3f826acefa6d57e5";

export default node;
